<body>
  <nav class="social-image">
    <ul>
      <li>
        <a
          href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
          target="_blank"
          rel="noopener"
          >Facebook <i class="fa fa-facebook"></i
        ></a>
      </li>
      <li>
        <a href="https://twitter.com/ONPASSIVE" target="_blank" rel="noopener"
          >Twitter <i class="fa fa-twitter"></i
        ></a>
      </li>
      <li>
        <a
          href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
          target="_blank"
          rel="noopener"
          >Youtube <i class="fa fa-youtube"></i
        ></a>
      </li>
      <li>
        <a href="http://onpassive.com/blog" target="_blank" rel="noopener"
          >ONPASSIVE Blog<i class="fa fa-clipboard"></i
        ></a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/ONPASSIVE/"
          target="_blank"
          rel="noopener"
          >Instagram <i class="fa fa-instagram"></i
        ></a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
          target="_blank"
          rel="noopener"
          >LinkedIn <i class="fa fa-linkedin"></i
        ></a>
      </li>
    </ul>
  </nav>
  <!--   </div> -->
  <section class="background">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-7">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="logo text-center">
                <img
                  src="{{ onPassiveBaseUrl }}onpassive(dec-16)/image/logo.png" alt="logo"
                />
              </div>
              <div class="content mt-3">
                <h3 class="content2" data-aos-easing="ease-out-cubic">
                  NEW <span class="revolutionized">REVOLUTIONIZED</span><br />
                  INTERNET MARKETING SOLUTIONS
                </h3>
                <h3 class="content1" data-aos-easing="linear">
                  <h1 class="content3">LAUNCHING SOON!</h1>
                  <p class="content4">
                    Money can't buy a rare opportunity. Never look away when you
                    see one. Join ONPASSIVE to get access to a bundle of
                    business opportunities and satisfy your appetite for
                    success.
                  </p>
                </h3>
              </div>
              <div class="video-box">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
                class="main-button"
              >
                <span class="ml3">become a founder now</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </section>
</body>
